import React from "react";
import { Icon } from "@iconify/react";
import { pageTitle } from "../../helpers/PageTitle";
import { BASE_URL } from "../../helpers/api";
import Section from "../Section";
import BannerSectionStyle4 from "../Section/BannerSection/BannerSectionStyle4";
import TeamSectionStyle2 from "../Section/TeamSection/TeamSectionStyle2";
import Breadcrumb from '../Breadcrumb';
import "../../sass/shortcode/DoctorsBanner.scss";


let teamData = [];
try {
  const doctorsData = await fetch(`${BASE_URL}/doctors/doc`);
  teamData = await doctorsData.json();
} catch (err) {
  console.error("Error fetching doctors:", err);
}
export default function Doctors() {
  pageTitle("Doctors");

  return (
    <>
      <section className="cs_doc_banner">
        <span className="cs_doc_dots cs_doc_dots_1" />
        <span className="cs_doc_dots cs_doc_dots_2" />
        <div className="container">
          <div className="cs_doc_banner_row">
            <div className="cs_doc_banner_left">
              <span className="cs_doc_label">Meet Our Team</span>
              <h1>Introduce You to Our Experts</h1>
              <span className="cs_doc_underline" />
              <p>
                The list of certified doctors with years of professional
                experience
              </p>
              <div className="cs_doc_stats">
                <div className="cs_doc_stat">
                  <span className="cs_doc_stat_icon">
                    <Icon icon="mdi:doctor" />
                  </span>
                  <span className="cs_doc_stat_number">50+</span>
                  <span className="cs_doc_stat_label">Specialists</span>
                </div>
                <div className="cs_doc_stat">
                  <span className="cs_doc_stat_icon">
                    <Icon icon="mdi:medal-outline" />
                  </span>
                  <span className="cs_doc_stat_number">10+</span>
                  <span className="cs_doc_stat_label">Years of Experience</span>
                </div>
                <div className="cs_doc_stat">
                  <span className="cs_doc_stat_icon">
                    <Icon icon="mdi:account-group-outline" />
                  </span>
                  <span className="cs_doc_stat_number">1000+</span>
                  <span className="cs_doc_stat_label">Happy Patients</span>
                </div>
              </div>
            </div>
            <div className="cs_doc_banner_right">
              <div className="cs_doc_img_wrap">
                <img src="/images/doctors/doctorsimg.jpg" alt="Our Doctors" />
              </div>
              <span className="cs_doc_wave" />
            </div>
          </div>
        </div>
      </section>

          {/* <Section topMd={50} bottomMd={36} bottomLg={10}>
              <Breadcrumb title="Meet Our Expert" />
            </Section> */}

            <Section topMd={50}  bottomLg={10}>
              <div className="container">
                <h2>Meet Our Experts</h2>
              </div>
            </Section>
      
      <Section topMd={0} bottomMd={10} bottomLg={0} bottomXl={10}>
        <TeamSectionStyle2 data={teamData} />
      </Section>
      {/* <Section className="cs_footer_margin_0">
        <BannerSectionStyle4
          bgUrl="images/doctors/doctorsimg3.webp"
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
        />
      </Section> */}
    </>
  );
}